import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type CheckMeshfaStatusResponsePayload = {
  meshfaDone: boolean
  hasMeshfaClient: boolean
}

export const CheckMeshfaStatusResponsePayloadSchema: CborSchema<CheckMeshfaStatusResponsePayload> =
  defineCborSchema<CheckMeshfaStatusResponsePayload>({
    meshfaDone: CborField({ key: 0 }),
    hasMeshfaClient: CborField({ key: 1 }),

  })
